/* eslint-disable */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-props-no-spreading */
import { useState } from "react";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { useMutation } from "react-query";
import { Button, TextField } from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import CustomCheckBox from "../../../shared/CustomCheckBox";
import CustomTextField from "../../../shared/CustomTextField";
import CustomDatePicker from "src/shared/CustomDatePicker";
import UploadDocument from "src/shared/UploadDocument";
import CustomBoxModal from "src/shared/CustomModalBox";
import { EInsurerType } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import { loanPageHelperText } from "src/helpers/FormDetails/ProposalDetails/resources";
import { OPTIONS } from "src/helpers/Dashboard/resources";
import { documentUploaded } from "src/services/UploadSignedMefForm";

interface Props {
  formik: any;
  insurerType: EInsurerType;
}

const VerifyOtpReviewDetails = ({ formik, insurerType }: Props) => {
  const leadId = useAppSelector((state) => state?.common?.leadId);
  const SignatureFile = useAppSelector((state) => state?.signatureForm.uploadedFile) || "";
  const [showSignatureUploadForm, setShowSignatureUploadForm] = useState(false);
  const [signatureFile, setSignatureFile] = useState<File | null>(null);
  const [uploadedFileName, setUploadedFileName] = useState("");

  const signatureUploadMutation = useMutation(documentUploaded, {
    retry: false
  });

  const handleSignatureSubmit = async () => {
    if (signatureFile) {
      const DocName =
        insurerType === EInsurerType.PRIMARY ? "Signature_Primary" : "Signature_Joint";
      try {
        await signatureUploadMutation.mutateAsync({
          leadId: leadId,
          file: signatureFile,
          DocName // Use the provided file name
        });
        setUploadedFileName(signatureFile.name);
        setShowSignatureUploadForm(false);
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const handleSignatureIconClick = () => {
    setShowSignatureUploadForm(true);
  };

  return (
    <div>
      {showSignatureUploadForm && (
        <CustomBoxModal
          onClose={() => {
            setShowSignatureUploadForm(false);
          }}
        >
          <div className="pb-4 md:px-4">
            <UploadDocument
              className="w-64 md:w-96"
              title="Upload Signature"
              description={signatureFile?.name || "Click/Drag & Drop to upload"}
              supportedFileText="SVG,PNG,JPG,PDF,GIF"
              setFile={setSignatureFile}
              acceptedFiles={OPTIONS?.signatureExtensionSupported}
            />
            <div className="text-center px-4 mt-2">
              <Button
                disabled={
                  !signatureFile ||
                  !OPTIONS?.signatureExtensionSupported.includes(
                    `.${signatureFile?.name.split(".").pop()?.toLowerCase()}`
                  )
                }
                variant="contained"
                onClick={handleSignatureSubmit}
                className="!capitalize h-10 w-32 rounded-lg"
              >
                Upload
              </Button>
            </div>
          </div>
        </CustomBoxModal>
      )}
      <div className="xl:w-290 mx-auto bg-white mt-7 pt-8.5 pb-10 rounded-xl">
        <div className="pr-10 pl-10.25 text-justify">
          <CustomCheckBox
            label={loanPageHelperText.customerDeclaration}
            name="declaration"
            handleBlur={formik.handleBlur}
            setFieldValue={formik.setFieldValue}
            checked={formik.values.declaration}
          />
          <div className="flex flex-col ml-7 mr-4 font-montserrat text-sm font-medium">
            <p>{loanPageHelperText.customerDeclarationSubPart_1}</p>
            <p>{loanPageHelperText.customerDeclarationSubPart_2}</p>
            <p>{loanPageHelperText.customerDeclarationSubPart_3}</p>
          </div>
        </div>
        <div>
          <div className="lg:flex">
            <div className="pl-20 mt-8">
              <CustomTextField
                disabledField
                className="w-64 h-13.5"
                requiredStar
                label="Name of Policy Holder"
                onChange={formik.handleChange}
                handleBlur={formik.handleBlur}
                value={formik.values.nameofPolicyHolder}
                name="nameofPolicyHolder"
                error={formik.errors.nameofPolicyHolder}
                touched={formik.touched.nameofPolicyHolder}
              />
            </div>
            <div className="mt-8 lg:ml-10 max-lg:ml-20">
              <CustomTextField
                className="w-64 h-13.5"
                requiredStar
                label="Place"
                onChange={formik.handleChange}
                handleBlur={formik.handleBlur}
                value={formik.values.place}
                name="place"
                error={formik.errors.place}
                touched={formik.touched.place}
              />
            </div>
            <div className="mt-8 lg:ml-10 max-lg:ml-20">
              <CustomDatePicker
                disableField
                requiredStar
                disableFuture
                className="w-64"
                value={formik.values.date}
                label="Date"
                setFieldValue={formik.setFieldValue}
                name="date"
                error={formik.errors.date}
                touched={formik.touched.date}
                setFieldTouched={formik.setFieldTouched}
              />
            </div>
          </div>
          <div className="pl-20 mt-8 flex">
            <div onClick={handleSignatureIconClick}>
              <TextField
                className="border-green w-64 h-13.5 !text-black text-xs text-left !font-montserrat"
                InputLabelProps={{
                  classes: {
                    root: "!text-sm !leading-5 !font-medium !text-platinumGranite !font-montserrat !pt-0.5 !pb-2",
                    shrink: "!text-purpleComet !text-xs"
                  }
                }}
                InputProps={{
                  readOnly: true,
                  value: uploadedFileName || SignatureFile || ""
                }}
                id="standard-basic"
                label="Signature/Thumb Impression"
                variant="standard"
              />
              <FileUploadOutlinedIcon className="mt-4 cursor-pointer" />
              <hr className="w-64 h-9 border-green" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyOtpReviewDetails;
